<template>
    <div>
        <page-title-bar></page-title-bar>
        <v-container grid-list-xl>
            <page-tool-bar
                show_search
                show_date_start
                show_date_end
                show_building
                show_agent
                :search.sync="search"
                :date_start.sync="date_start"
                :date_end.sync="date_end"
                :chosen_building.sync="chosen_building"
                :agent_id.sync="agent_id"
                :loading="loader"
            >
                <v-flex shrink class="px-0">
                    <v-btn :disabled="loader" @click="print++" color="primary">
                        <v-icon small left>print</v-icon>In danh sách
                    </v-btn>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <table-dan-phong
                        :search="search"
                        :date_start="date_start"
                        :date_end="date_end"
                        :agent_id="agent_id"
                        :chosen_building="chosen_building"
                        :print="print"
                        @mutateLoader="loader = $event"
                    ></table-dan-phong>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import TableDanPhong from "./TableDanPhong";
import moment from "moment";
export default {
    name: "tien-dan-phong",
    components: {
        TableDanPhong
    },
    data() {
        return {
            search: "",
            date_start: moment()
                .startOf("month")
                .format("YYYY-MM-DD"),
            date_end: new Date().toISOString().substring(0, 10),
            chosen_building: "",
            agent_id: null,
            loader: false,
            print: 0
        };
    },
    watch: {
        agent_id(nv) {
            console.log(nv);
        }
    }
};
</script>

<style>
</style>